<template>
  <div class="product-item-wrap" :class="[type, { active }]" @click="handleClick">
    <div class="product-item-bg"></div>
    <div class="product-item-inner">
      <div class="prop-area">
        <div class="prop-icon-wrap">
          <img class="coin-icon" :src="coinIcon" alt="coin">
        </div>
        <div class="coin-title" :class="locale">
          {{ localeFormatNumber(item.coin) }} {{ $t('payment.product.diamond') }}
        </div>
        <div class="coin-total" v-if="giftTotal">
          {{ $t('payment.product.coinTotal', {
            total: localeFormatNumber(totalCoin),
            coin: localeFormatNumber(item.coin),
            gift: localeFormatNumber(giftTotal)
          }) }}
        </div>
        <div class="coin-total" v-else>
          {{ $t('payment.product.coinTotalOnly', { total: localeFormatNumber(item.coin) }) }}
        </div>
      </div>

      <div class="bonus-row" v-if="item.regularGiftCoin || item.points">
        <div class="bonus-item" v-if="item.regularGiftCoin">
          {{ $t('payment.product.giftRegularBadge', { num: localeFormatNumber(item.regularGiftCoin) }) }}
        </div>
        <div class="bonus-item" v-if="item.points">
          {{ $t('payment.product.giftPointsBadge', { num: localeFormatNumber(item.points) }) }}
        </div>
      </div>

      <div class="price-wrap">
        <span class="currency">{{ item.currency }}</span>
        <span class="price">{{ calcProductPrice(item.price) }}</span>
      </div>
    </div>

    <!-- 活动加赠标签 -->
    <div class="activity-tag" v-if="item.activityGiftCoin">
      <div class="tag-left" :class="locale">
        <i18n-t keypath="payment.product.giftActivityBadge" tag="span">
          <template #num>
            <span class="tag-num">
              +{{ localeFormatNumber(item.activityGiftCoin) }}
              <img class="tag-diamond" src="@/assets/imgs/icon-coin.png" alt="diamond">
            </span>
          </template>
        </i18n-t>
      </div>
      <template v-if="item.isLimit">
        <div class="tag-divider"></div>
        <div class="tag-right">
          {{ $t('payment.product.remaining', { num: item.limitCount }) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { isMobile, formatNumber } from '@/utils'
import { useStore } from 'vuex'

import coin1 from '@/assets/imgs/coin/1.png'
import coin2 from '@/assets/imgs/coin/2.png'
import coin3 from '@/assets/imgs/coin/3.png'
import coin4 from '@/assets/imgs/coin/4.png'

const type = isMobile ? 'mobile' : 'pc'
const store = useStore()
const locale = computed(() => store.state.locale)

const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  active: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['select'])

const localeFormatNumber = (number) => {
  return formatNumber(number, locale.value)
}

const calcProductPrice = (price) => {
  return localeFormatNumber(price / 100)
}

const giftTotal = computed(() => {
  return (props.item.regularGiftCoin || 0) + (props.item.activityGiftCoin || 0)
})

const totalCoin = computed(() => {
  return (props.item.coin || 0) + giftTotal.value
})

const coinIcon = computed(() => {
  const coin = props.item.coin || 0
  if (coin > 3000) return coin4
  if (coin > 1500) return coin3
  if (coin > 500) return coin2
  return coin1
})

const handleClick = () => {
  emit('select', props.item)
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
